import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import UserAndCustomerData from "./modules/AccountData.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state:{
    isDownloadRequested: false,
    dbIdentifier: '',
    dbType: '',
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  modules: {
    UserAndCustomerData
  }
  // plugins: [pathify.plugin]
});

export default store;
